"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toFeature = exports.features = exports.PlaceFeatureType = void 0;
var PlaceFeatureType;
(function (PlaceFeatureType) {
    PlaceFeatureType[PlaceFeatureType["SECURITY_24"] = 0] = "SECURITY_24";
    PlaceFeatureType[PlaceFeatureType["SECURITY_DAYTIME"] = 1] = "SECURITY_DAYTIME";
    PlaceFeatureType[PlaceFeatureType["ALLOW_PETS"] = 2] = "ALLOW_PETS";
    PlaceFeatureType[PlaceFeatureType["BBQ"] = 3] = "BBQ";
    PlaceFeatureType[PlaceFeatureType["CLUB_HOUSE"] = 4] = "CLUB_HOUSE";
    PlaceFeatureType[PlaceFeatureType["CONVENIENCE_STORE"] = 5] = "CONVENIENCE_STORE";
    PlaceFeatureType[PlaceFeatureType["COURT_BADMINTON"] = 6] = "COURT_BADMINTON";
    PlaceFeatureType[PlaceFeatureType["COURT_BB"] = 7] = "COURT_BB";
    PlaceFeatureType[PlaceFeatureType["COURT_SQUASH"] = 8] = "COURT_SQUASH";
    PlaceFeatureType[PlaceFeatureType["COURT_TENNIS"] = 9] = "COURT_TENNIS";
    PlaceFeatureType[PlaceFeatureType["GOLF_SIM"] = 10] = "GOLF_SIM";
    PlaceFeatureType[PlaceFeatureType["GYM"] = 11] = "GYM";
    PlaceFeatureType[PlaceFeatureType["PLAYGROUND"] = 12] = "PLAYGROUND";
    PlaceFeatureType[PlaceFeatureType["POOL_INDOOR"] = 13] = "POOL_INDOOR";
    PlaceFeatureType[PlaceFeatureType["POOL_INDOOR_HEATED"] = 14] = "POOL_INDOOR_HEATED";
    PlaceFeatureType[PlaceFeatureType["POOL_OUTDOOR"] = 15] = "POOL_OUTDOOR";
    PlaceFeatureType[PlaceFeatureType["POOL_OUTDOOR_HEATED"] = 16] = "POOL_OUTDOOR_HEATED";
    PlaceFeatureType[PlaceFeatureType["ROOM_FUNCTION"] = 17] = "ROOM_FUNCTION";
    PlaceFeatureType[PlaceFeatureType["ROOM_MULTIPURPOSE"] = 18] = "ROOM_MULTIPURPOSE";
    PlaceFeatureType[PlaceFeatureType["ROOM_SNOOKER"] = 19] = "ROOM_SNOOKER";
    PlaceFeatureType[PlaceFeatureType["SHUTTLE_BUS"] = 20] = "SHUTTLE_BUS";
    PlaceFeatureType[PlaceFeatureType["TABLE_TENNIS"] = 21] = "TABLE_TENNIS";
    PlaceFeatureType[PlaceFeatureType["CARPARK"] = 22] = "CARPARK";
})(PlaceFeatureType = exports.PlaceFeatureType || (exports.PlaceFeatureType = {}));
exports.features = [
    { type: PlaceFeatureType.SECURITY_24, key: 'featureSecurity24', icon: 'shield-alt' },
    { type: PlaceFeatureType.SECURITY_DAYTIME, key: 'featureSecurityDaytime', icon: 'shield-alt' },
    { type: PlaceFeatureType.ALLOW_PETS, key: 'featureAllowPets', icon: 'paw' },
    { type: PlaceFeatureType.BBQ, key: 'featureBbq', icon: 'burn' },
    { type: PlaceFeatureType.CLUB_HOUSE, key: 'featureClubHouse', icon: 'tablets' },
    { type: PlaceFeatureType.CONVENIENCE_STORE, key: 'featureConvenienceStore', icon: 'store' },
    { type: PlaceFeatureType.COURT_BADMINTON, key: 'featureCourtBadminton', icon: 'shuttlecock' },
    { type: PlaceFeatureType.COURT_BB, key: 'featureCourtBb', icon: 'basketball-ball' },
    { type: PlaceFeatureType.COURT_SQUASH, key: 'featureCourtSquash', icon: 'racquet' },
    { type: PlaceFeatureType.COURT_TENNIS, key: 'featureCourtTennis', icon: 'tennis-ball' },
    { type: PlaceFeatureType.GOLF_SIM, key: 'featureGolfSim', icon: 'golf-ball' },
    { type: PlaceFeatureType.GYM, key: 'featureGym', icon: 'dumbbell' },
    { type: PlaceFeatureType.PLAYGROUND, key: 'featurePlayground', icon: 'dreidel' },
    { type: PlaceFeatureType.POOL_INDOOR, key: 'featurePoolIndoor', icon: 'swimmer' },
    { type: PlaceFeatureType.POOL_INDOOR_HEATED, key: 'featurePoolIndoorHeated', icon: 'swimmer' },
    { type: PlaceFeatureType.POOL_OUTDOOR, key: 'featurePoolOutdoor', icon: 'swimmer' },
    { type: PlaceFeatureType.POOL_OUTDOOR_HEATED, key: 'featurePoolOutdoorHeated', icon: 'swimmer' },
    { type: PlaceFeatureType.ROOM_FUNCTION, key: 'featureRoomFunction', icon: 'check-circle ' },
    { type: PlaceFeatureType.ROOM_MULTIPURPOSE, key: 'featureRoomMultiPurpose', icon: 'check-circle' },
    { type: PlaceFeatureType.ROOM_SNOOKER, key: 'featureRoomSnooker', icon: 'dot-circle' },
    { type: PlaceFeatureType.SHUTTLE_BUS, key: 'featureShuttleBus', icon: 'bus' },
    { type: PlaceFeatureType.TABLE_TENNIS, key: 'featureTableTennis', icon: 'table-tennis' },
    { type: PlaceFeatureType.CARPARK, key: 'featureCarpark', icon: 'parking' },
];
exports.toFeature = function (id) {
    var type;
    switch (id) {
        case 1: {
            type = PlaceFeatureType.PLAYGROUND;
            break;
        }
        case 2: {
            type = PlaceFeatureType.GYM;
            break;
        }
        case 3: {
            type = PlaceFeatureType.POOL_INDOOR;
            break;
        }
        case 4: {
            type = PlaceFeatureType.COURT_TENNIS;
            break;
        }
        case 5: {
            type = PlaceFeatureType.COURT_BB;
            break;
        }
        case 6: {
            type = PlaceFeatureType.COURT_SQUASH;
            break;
        }
        case 7: {
            type = PlaceFeatureType.TABLE_TENNIS;
            break;
        }
        case 8: {
            type = PlaceFeatureType.BBQ;
            break;
        }
        case 9: {
            type = PlaceFeatureType.CLUB_HOUSE;
            break;
        }
        case 10: {
            type = PlaceFeatureType.SHUTTLE_BUS;
            break;
        }
        case 12: {
            type = PlaceFeatureType.SECURITY_24;
            break;
        }
        case 13: {
            type = PlaceFeatureType.SECURITY_DAYTIME;
            break;
        }
        case 14: {
            type = PlaceFeatureType.CARPARK;
            break;
        }
        case 15: {
            type = PlaceFeatureType.CONVENIENCE_STORE;
            break;
        }
        case 16: {
            type = PlaceFeatureType.COURT_BADMINTON;
            break;
        }
        case 17: {
            type = PlaceFeatureType.GOLF_SIM;
            break;
        }
        case 18: {
            type = PlaceFeatureType.POOL_OUTDOOR;
            break;
        }
        case 19: {
            type = PlaceFeatureType.ROOM_FUNCTION;
            break;
        }
        case 20: {
            type = PlaceFeatureType.ROOM_MULTIPURPOSE;
            break;
        }
        case 21: {
            type = PlaceFeatureType.ROOM_SNOOKER;
            break;
        }
        case 22: {
            type = PlaceFeatureType.TABLE_TENNIS;
            break;
        }
        case 23: {
            type = PlaceFeatureType.ALLOW_PETS;
            break;
        }
    }
    var feature = exports.features.filter(function (it) { return it.type === type; });
    return feature.length ? feature[0] : null;
};
